import api from '.'

export const nutrition = {
  search (dataType, term, success, fail) {
    api.authenticatedRequest('GET', `/nutrition/${dataType}/${term}`, null, success, fail)
  }
}
